import { Box, TextInput } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { AgGridReact } from "ag-grid-react";
import { ColDef, ICellRendererParams, RowClassParams, RowClickedEvent } from "ag-grid-enterprise";
import {
  ISpaceNumberAndSpaceValidationsResults,
  setSelectedSpaceNumberInRedux,
} from "../designSlice";
import { useState } from "react";
import VSpace from "../../VSpace";
import {
  allValidationsAreValid,
  ISpaceValidation,
} from "../../RoomSideBar/SpaceValidations/spaceValidationsUtils";
import { InvalidIcon, ValidIcon } from "../../PingToPyCeiling";

export const SpaceValidationTablePanel: React.FC = () => {
  const [filterText, setFilterText] = useState<string>("");

  const dispatch = useAppDispatch();

  const selectedSpaceNumber = useAppSelector((state) => state.design.selectedSpaceNumber);

  const spaceValidationRun = useAppSelector((state) => state.design.spaceValidationRun);

  const columns: ColDef<ISpaceNumberAndSpaceValidationsResults>[] = [
    {
      field: "spaceNumber",
      headerName: "",
      width: 60,
      cellRenderer: (params: ICellRendererParams<ISpaceNumberAndSpaceValidationsResults>) => {
        const allValid = allValidationsAreValid(
          params.data?.spaceValidations as ISpaceValidation[]
        );
        return (
          <div>
            {allValid && <ValidIcon />}
            {!allValid && <InvalidIcon />}
          </div>
        );
      },
    },
    {
      field: "spaceNumber",
      headerName: "Romnummer",
      flex: 1,
    },
  ];

  const rowClassRules = {
    "ag-row-selected": (params: RowClassParams<ISpaceNumberAndSpaceValidationsResults>) =>
      params.data?.spaceNumber === selectedSpaceNumber,
  };

  return (
    <Box h="100%" p="3">
      <TextInput
        placeholder="Søk"
        value={filterText}
        onChange={(e) => setFilterText(e.target.value)}
      ></TextInput>
      <VSpace />
      <div className="ag-theme-quartz" style={{ overflow: "auto", width: "100%", height: "100%" }}>
        <AgGridReact
          quickFilterText={filterText}
          onRowClicked={(event: RowClickedEvent<ISpaceNumberAndSpaceValidationsResults>) => {
            dispatch(setSelectedSpaceNumberInRedux(event.data?.spaceNumber as string));
          }}
          columnDefs={columns}
          rowData={spaceValidationRun.spacesValidationsResults}
          rowClassRules={rowClassRules}
        />
      </div>
    </Box>
  );
};
